require "../models/value_adds_model"

class Extranet.Collections.ValueAdds extends Backbone.Collection
  url: "/v2/getaways/extranet/value_adds"
  model: Extranet.Models.ValueAddModel
